import { AppEnv } from './environment.interface';

export const environment: AppEnv = {
  apiUrl: 'https://h-api.opencharge.com.br',
  apiUrlV2: 'https://hom-api2.mycharge.com.br',
  apiUrlV3: 'https://hom-api.mycharge.com.br',
  imageHandlerUrl: 'https://hom-api.mycharge.com.br/image-handler?file=',
  fileUploadUrl: 'https://hom-api.mycharge.com.br',
  appVersion: '6.10.27.0',
  appKey: '00xFE0398B65',
  iv: 'RmVycmFtZW50YUNlcnRhQHRvb2tpdCoyMzM=',
  debounceTime: 500,
};
